import React from "react";
import { AiFillAppstore } from "react-icons/ai";
import { MdSwapHorizontalCircle } from "react-icons/md";
import { FaRobot } from "react-icons/fa6";
import { FaUserLock } from "react-icons/fa";

export default function MainSection1() {
  return (
    <div>
      <div className="lg:mt-6 px-4 py-12 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
        <div className="flex flex-col justify-center mb-6 lg:justify-center lg:flex-row md:mb-8">
          <h2 className="max-w-4xl mb-5 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none md:mb-6 group">
            <span className="inline-block mb-1 sm:mb-4">
              Why AeroGenix AI Stands Out ?
            </span>
            <div className="h-1 ml-auto duration-300 origin-left transform bg-primary scale-x-30 group-hover:scale-x-100" />
          </h2>
        </div>

        <section className="py-4 bg-base-100">
          <div className="container mx-auto px-2">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-14">
              {[
                {
                  icon: <AiFillAppstore />,
                  title: "End-to-End AI Enablement",
                  description:
                    "From data integration to deployment and ROI measurement, AeroGenix AI offers a complete solution.",
                },
                {
                  icon: <MdSwapHorizontalCircle />,
                  title: "BYOD & BYOM Flexibility",
                  description:
                    "Your data. Your models. AeroGenix AI works the way you do.",
                },
                {
                  icon: <FaRobot />,
                  title: "Intelligent Agents, Built Simply",
                  description:
                    "Create sophisticated autonomous agents with no coding expertise required.",
                },
                {
                  icon: <FaUserLock />,
                  title: "Security & Compliance First",
                  description:
                    "AeroGenix AI prioritizes your enterprise's trust and safety.",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="card border border-primary shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 lg:w-[220px] xl:w-[300px] h-[300px]"
                >
                  <div className="card-body flex flex-col items-center text-center p-6">
                    <div className="text-4xl text-primary mb-4">
                      {item.icon}
                    </div>
                    <h3 className="text-xl font-semibold mb-3 min-h-[60px]">{item.title}</h3>
                    <p className="text-gray-700 leading-relaxed min-h-[70px]">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}